import { CarlineWithOfertas, Oferta } from '../services/ofertas-service/models/ofertas';
import { useTrackingManager } from '../tracking/use-tracking-manager';
import { getFinanciacionType, getPagoFinanciado, getPagoUnico } from './ofertas-helper';

export const useOfertasTracker = () => {
	const trackingManager = useTrackingManager();

	const getPayload = (carline?: CarlineWithOfertas, oferta?: Oferta) => {
		const carlineOk = carline || oferta?.carline;
		const ofertaOk = oferta || carline?.ofertas[0];

		if (!carlineOk || !ofertaOk) return undefined;

		const pagoFinanciado = getPagoFinanciado(ofertaOk.datosEconomicos);
		const pagoUnico = getPagoUnico(ofertaOk.datosEconomicos);

		return {
			CarlineId: carlineOk.code.toString(),
			CarlineName: carlineOk.title,
			ModelId: ofertaOk.configuracion.motorizacion.code?.split('-')[0],
			ModelName: ofertaOk.carline?.salesgroup.model.name,
			ModelYear: ofertaOk.carline?.salesgroup.year.toString(),
			SalesgroupName: ofertaOk.carline?.salesgroup.title,
			PriceRateType: pagoFinanciado ? getFinanciacionType(pagoFinanciado, carline?.brand) : undefined,
			PriceRateTotal: pagoFinanciado?.precio ?? undefined,
			PriceRateCurrency: 'EUR',
			PriceTotalTotal: pagoUnico?.precio ?? undefined,
			PriceTotalCurrency: 'EUR',
		};
	};

	const trackOfertasModelSelectClick = (carline: CarlineWithOfertas) => {
		const payload = getPayload(carline);
		if (payload) trackingManager.trackOfertasModelSelectClick(payload);
	};

	const trackOfertasVehiclePageLoad = (carline: CarlineWithOfertas) => {
		const payload = getPayload(carline);
		if (payload) trackingManager.trackOfertasVehiclePageload(payload);
	};

	const trackOfertasVehicleLoad = (carline: CarlineWithOfertas) => {
		const payload = getPayload(carline);
		if (payload) trackingManager.trackOfertasVehicleLoad(payload);
	};

	const trackOfertasGenericFeatureAppLoad = (carline: CarlineWithOfertas) => {
		const payload = getPayload(carline);
		if (payload) trackingManager.trackOfertasGenericFeatureAppLoad(payload);
	};

	const trackOfertasButtonClick = (contentId: string, oferta: Oferta, carline?: CarlineWithOfertas, id?: string) => {
		const payload = getPayload(carline, oferta);
		if (payload) trackingManager.trackOfertasButtonClick(id ? id : contentId, { contentId: contentId }, payload);
	};

	const trackOfertasLayerLoad = (contentId: string, oferta: Oferta, carline: CarlineWithOfertas) => {
		const payload = getPayload(carline, oferta);
		if (payload) trackingManager.trackOfertasLayerLoad({ contentId: contentId }, payload);
	};

	const trackOfertasLayerClose = (contentId: string, oferta: Oferta, carline: CarlineWithOfertas, id?: string) => {
		const payload = getPayload(carline, oferta);
		if (payload) trackingManager.trackOfertasLayerClose(id ? id : contentId, { contentId: contentId }, payload);
	};

	const trackOfertasLinkClick = (contentId: string, oferta: Oferta, carline: CarlineWithOfertas, id?: string) => {
		const payload = getPayload(carline, oferta);
		if (payload) trackingManager.trackOfertasLinkClick(id ? id : contentId, { contentId: contentId }, payload);
	};

	const trackOfertasFilterSelectClick = (selector: string) => {
		trackingManager.trackOfertasFilterSelectClick({
			type: 'single_value',
			name: 'FT',
			values: [selector],
		});
	};

	const trackOfertasElementSwipe = (carline: CarlineWithOfertas, oferta?: Oferta) => {
		const payload = getPayload(carline, oferta);
		trackingManager.trackOfertasElementSwipe(payload);
	};

	return {
		trackOfertasModelSelectClick,
		trackOfertasVehiclePageLoad,
		trackOfertasVehicleLoad,
		trackOfertasGenericFeatureAppLoad,
		trackOfertasButtonClick,
		trackOfertasLayerLoad,
		trackOfertasLayerClose,
		trackOfertasLinkClick,
		trackOfertasFilterSelectClick,
		trackOfertasElementSwipe,
	};
};
